import { Region } from '../region';
import { IPaymentProvider } from '../../providers/payment/payment.interface'
import { PaymentProviderFiserv } from '../../providers/payment/payment.fiserv'

/**
 * @description Geographical region the application is currently configured for, e.g. US, Spain, Australia.
 * @region Enumeration for this region.
 * @defaultCountryFrom Default value to use for send-from country, i.e. in price calculator
 * @defaultCurrencyFrom Default value to use for send-from currency, i.e. in price calculator
 * @defaultLanguage Default language culture to use, i.e. content translations
 */
export const regionValues = {
  region: Region.SG,
  regionId: 2005,
  defaultCountryFrom: 'SG',
  defaultCountryFromOnfido: 'SGP',
  defaultCountryCodeFrom: 65,
  defaultCurrencyFrom: 'SGD',
  defaultLanguageCulture: 'en-SG',
  defaultLocation: {
    latitude: 1.290270,
    longitude: 103.851959
  },
  dateFormat: 'DD/MM/YYYY',
  postalCodeRegex:`^\\d{6}$`,
  links: {
    linkFaq: 'https://www.riamoneytransfer.com/us/en/mobile-content/faqs'
  },
  languageCultures: ['en-SG', 'ms-SG'],
  regionalIp: '66.82.123.234',
  paymentProvider: <IPaymentProvider>new PaymentProviderFiserv(),
  isPlaidEnabled: false,
  isBankAccountEnabled:false,
  useSecurityQuestions: false,
  oldRemittanceLogin: false,
  onfidoMaxAttempts: 0,
  directBankBrand: '',
  distanceMetric: 'km',
  acceptInternationalCards:false,
  stagedRiaBrand: '',
  payNearMeBrand: '',
  isEu: false,
  isEMEA: false,
  notShowMarketingPushAlert: true,
  googlepayAdyenPaymentNetworks: [],
  applepayAdyenPaymentNetworks: [],
  adyenMerchantCapability: [],
  walletSettings:{
    isMerchantSupportEnable:false,
  },
  defaultTranslationParams: null,
  originalCountryAllowedOnly: false,
  canShowLogosOnQRScanner: false,
  airtimeServices:{
    isAirTimeSevice:false,
    isLocalOnly:false,
  },
  passCodeLength: 6,
  walletServices:[],
  isCountrySupportDecimal: true,
  showNewHomePage: true,
  autoEnableMarketingPreference: false,
  loginRootHomePage: "activity",
  adyenRegion: 'live-apse'// https://docs.adyen.com/development-resources/live-endpoints/#client-side-environment-region
};



// WEBPACK FOOTER //
// ./src/environment/region/SG.ts